import { render, staticRenderFns } from "./BidsPage.vue?vue&type=template&id=4aa63627&"
import script from "./BidsPage.vue?vue&type=script&lang=js&"
export * from "./BidsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports